(function () {
  function mount(container) {
    var block = container.querySelector('[data-llsj-pdp-reviews]');
    if (!block || block.dataset.carouselMounted) return;
    var list = block.querySelector('[data-llsj-reviews-list]');
    var prev = block.querySelector('[data-llsj-reviews-prev]');
    var next = block.querySelector('[data-llsj-reviews-next]');
    if (!list || !prev || !next) return;
    block.dataset.carouselMounted = 'true';
    function sync() {
      var max = list.scrollWidth - list.clientWidth;
      prev.hidden = next.hidden = max <= 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max - 1;
    }
    function move(direction) {
      var card = list.querySelector('.llsj-reviews__item');
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      list.scrollBy({ left: direction * ((card ? card.getBoundingClientRect().width : list.clientWidth) + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      requestAnimationFrame(sync);
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    list.addEventListener('scroll', sync, { passive: true });
    list.addEventListener('scrollend', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(list);
    else window.addEventListener('resize', sync);
    sync();
  }
  function scan() { document.querySelectorAll('[data-ll-book-reviews]').forEach(mount); }
  scan();
  document.addEventListener('shopify:section:load', scan);
}());
